<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <GalleryForm @submit-requested="submitRequested"></GalleryForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import GalleryForm from './GalleryForm.vue'

  export default {
  components: { GalleryForm },
  methods: {
    ...mapActions('gallery', ['postGallery']),
    submitRequested (input) {
      this.postGallery(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 